export default function OrdersIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M414.23,138.03l-6.37-3.08L255.76,61.32c-3.64-1.76-7.88-1.76-11.52,0l-152.1,73.63-6.37,3.08c-4.6,2.23-7.5,6.9-7.46,12.01l.07,8.78,1.57,192.1c.04,5.03,2.93,9.6,7.45,11.79l148.83,72.09,8,3.88c3.65,1.76,7.89,1.76,11.54,0l8-3.88,148.83-72.09c4.52-2.19,7.41-6.76,7.45-11.79l1.57-192.1.07-8.78c.04-5.11-2.86-9.78-7.46-12.01ZM250,89.12l126.2,61.09-43.95,21.28-125.42-61.48,43.17-20.89ZM236.23,404.19l-128.82-62.39-1.38-169.52,130.2,63.09v168.82ZM250,211.31l-126.2-61.1,51.03-24.7,125.41,61.47-50.24,24.33ZM392.59,341.8l-128.82,62.39v-168.95l130.2-62.96-1.38,169.52Z"/>
    </svg>
  );
}
